import type { Canvas } from "fabric";
import { defineStore } from "pinia";
import { markRaw } from "vue";
import type { AlertType } from '@/constants/alertStyles'
import { MAX_BRUSH_SIZE, MIN_BRUSH_SIZE } from "@/constants/segmentation";

interface SegmentationCanvasState {
  canvasWidth: number;
  canvasHeight: number;
  baseCanvasJson: any;
  fabricCanvas: Canvas | null;
  canvasLoader: boolean;
  canvasError: boolean;
  globalLoader: boolean;
  canvasJson: any;
  canvasForImage: Record<string, any>;
  unselectMode: boolean;
  activeButton: string | null;
  canvasAlertType: AlertType | null;
  canvasMessage: string
  showCanvasAlert: boolean
  brushSize: number;
  hasBrushStroke: boolean;
}

export const useSegmentationCanvasStore = defineStore("segmentationCanvas", {
  state: (): SegmentationCanvasState => ({
    canvasWidth: 500,
    canvasHeight: 500,
    canvasJson: null,
    baseCanvasJson: null,
    fabricCanvas: null,
    canvasLoader: false,
    canvasError: false,
    globalLoader: false,
    canvasForImage: {},
    unselectMode: false,
    activeButton: null,
    canvasAlertType: null,
    canvasMessage : "",
    showCanvasAlert: false,
    brushSize: 20,
    hasBrushStroke: false,
  }),
  actions: {
    setCanvasDimensions(width: number, height: number) {
      this.canvasWidth = width;
      this.canvasHeight = height;
    },
    setBaseCanvasJson(json: any) {
      this.baseCanvasJson = json;
    },
    setCanvasJson(json: any) {
      this.canvasJson = json;
    },
    setCanvasLoader(isLoading: boolean) {
      this.canvasLoader = isLoading;
    },
    setGlobalLoader(isLoading: boolean) {
      this.globalLoader = isLoading;
    },
    setCanvasError(isError: boolean) {
      this.canvasError = isError;
    },
    setFabricCanvas(canvas: Canvas) {
      this.fabricCanvas = markRaw(canvas);
    },
    setCanvasForImage(key: string, json: any) {
      this.canvasForImage[key] = json;
    },
    reset() {
      this.canvasWidth = 500;
      this.canvasHeight = 500;
      this.baseCanvasJson = null;
      this.fabricCanvas = null;
      this.canvasLoader = false;
      this.canvasError = false;
      this.canvasJson = null;
      this.canvasForImage = {};
      this.setActiveButton(null);
      this.brushSize = 20;
      this.hasBrushStroke = false;
      this.setcanvasMessage("Ooops! Please Try Again!")
    },
    setActiveButton(button: string | null) {
      this.activeButton = button; 
    },
    setcanvasMessage(message : string){
      this.canvasMessage = message
    },
    setCanvasAlert(type: AlertType, message: string) {
      this.showCanvasAlert = true
      this.canvasAlertType = type
      this.canvasMessage = message
    },
    clearCanvasAlert() {
      this.showCanvasAlert = false
      this.canvasAlertType = null
      this.canvasMessage = ""
    },
    setBrushSize(size: number) {
      this.brushSize = Math.min(MAX_BRUSH_SIZE, Math.max(MIN_BRUSH_SIZE, size));
    },
    setHasBrushStroke(hasStroke: boolean) {
      this.hasBrushStroke = hasStroke;
    },
  },
});
